import type { AudioEngine } from "../host/engine";
import type { Instrument } from "../types";
import { isWavetableInstrument } from "../wavetable/preset";
import { wavetablePresetTableIds } from "../wavetable/preset";
import { getCachedWavetable, loadWavetableRuntime } from "../wavetable/loadTable";

/** Ensure all wavetable ids referenced by instruments are loaded into the kernel. */
export async function pushWavetablesForInstruments(
  engine: AudioEngine,
  instruments: Instrument[],
  assetsBaseUrl = "/assets/",
): Promise<void> {
  const ids = new Set<string>();
  for (const instrument of instruments) {
    if (!isWavetableInstrument(instrument)) {
      continue;
    }
    for (const id of wavetablePresetTableIds(instrument.preset)) {
      ids.add(id);
    }
  }
  for (const id of ids) {
    let table = getCachedWavetable(id);
    if (!table) {
      table = await loadWavetableRuntime(id, assetsBaseUrl);
    }
    engine.transport.loadWavetable(table);
  }
}
